import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { taxonomyHostClient } from '../../../restClient';
import SimpleDropdown from '../SimpleDropdown';
import './SweepFrequencyPicker.css';

const WEEKLY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:weekly';
const MONTHLY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly';
const QUARTERLY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:quarterly';
const ANNUALLY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:annually';
const CALENDER_DATE = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:calenderDate';
const SPECIFIC_DAY = 'urn:hsbc:cmb:gdocs:products:taxonomies:frequency:monthly:specificDay';

class SweepFrequencyPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sweepFrequency: {
        frequencyType: '',
        frequencyDetails: '',
        frequencyDetailValue: '',
        dates: [],
        isNAChecked: false,
      },
      sweepFrequencyDataDictionary: [],
      noOfDates: 1,
      validationMgs: false,
      weeklyDisabled: false,
      isDisabled: false,
      dateOptions: [],
      settlementType: {}
    };
    this.defaultPicks = {};
    this.defaultDropdownValue = '';
  }

  componentWillMount() {
    if (this.props.dataDictionaryURI !== undefined) {
      taxonomyHostClient(this.props.dataDictionaryURI)
        .then(({ data }) => {
          this.setState({ sweepFrequencyDataDictionary: data.responseData.classificationNodes });
          this.pickDefaultsFromDataDictionary(data.responseData.classificationNodes);
        });
    } else if (this.props.dataDictionary !== undefined) {
      this.setState({ sweepFrequencyDataDictionary: this.props.dataDictionary });
      this.pickDefaultsFromDataDictionary([...this.props.dataDictionary]);
    } else {
      throw new Error('Either Data Dictionary (dataDictionary) or Data Dictionary URI (dataDictionaryURI) is required');
    }

    if (this.props._value !== undefined) {
      var noOfDates = 1;
      if (this.props._value.dates) {
        noOfDates = this.props._value.dates.length === 0 ? 1 : this.props._value.dates.length;
      }
      this.setState({
        sweepFrequency: this.props._value,
        noOfDates
      });
    }
  }
  // componentWillReceiveProps (nextProps){
  //   if(nextProps._value !== undefined) {
  //     var noOfDates = 1;
  //     if(nextProps._value.dates) {
  //       noOfDates = nextProps._value.dates.length === 0 ? 1 : nextProps._value.dates.length;
  //     }
  //     this.setState({
  //       sweepFrequency: nextProps._value,
  //       noOfDates
  //     });
  //   }``
  // }


  componentWillReceiveProps(nextProps) {
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
      taxonomyHostClient(nextProps.dataDictionaryURI)
        .then(({ data }) => {
          this.setState({ sweepFrequencyDataDictionary: data.responseData.classificationNodes });
          this.pickDefaultsFromDataDictionary(data.responseData.classificationNodes);
        });
    }
    if (nextProps._value !== this.props._value && nextProps._value !== undefined) {
      var noOfDates = 1;
      if (nextProps._value.dates) {
        noOfDates = nextProps._value.dates.length === 0 ? 1 : nextProps._value.dates.length;
      }
      this.setState({
        sweepFrequency: nextProps._value,
        noOfDates
      });
    }
  }
  pickDefaultsFromDataDictionary = (dataDictionary) => {
    dataDictionary.forEach(dd => {
      this.defaultPicks[dd.id] = dd.associations ? { name: dd.associations[0].name, value: dd.associations[0].id } : undefined;
      if (dd.associations) {
        dd.associations.forEach(subDd => {
          this.defaultPicks[subDd.id] = subDd.associations ? { name: subDd.associations[0].name, value: subDd.associations[0].id } : undefined;
        });
      }
    });
  }

  setDefaultSelections = (fieldName, sweepFrequency) => {
    //this.defaultPicks[WEEKLY]
    if (fieldName === 'frequencyType' && sweepFrequency.frequencyType.value === WEEKLY) {
      sweepFrequency.frequencyDetails = { name: '', value: '' };
      sweepFrequency.frequencyDetailValue = undefined;
      sweepFrequency.annualDate = undefined;
      sweepFrequency.dates = undefined;
    } else if (fieldName === 'frequencyType' && sweepFrequency.frequencyType.value === MONTHLY) {
      sweepFrequency.frequencyDetails = { name: '', value: '' };
      sweepFrequency.frequencyDetailValue = undefined;
      sweepFrequency.annualDate = undefined;
      sweepFrequency.dates = undefined;
    } else if (fieldName === 'frequencyType' && sweepFrequency.frequencyType.value === ANNUALLY) {
      sweepFrequency.frequencyDetails = undefined;
      sweepFrequency.frequencyDetailValue = undefined;
      sweepFrequency.annualDate = '';
      sweepFrequency.dates = undefined;
    } else if (fieldName === 'frequencyType' && sweepFrequency.frequencyType.value === CALENDER_DATE) {
      sweepFrequency.frequencyDetails = undefined;
      sweepFrequency.frequencyDetailValue = undefined;
      sweepFrequency.annualDate = undefined;
      sweepFrequency.dates = [];
    } else if (fieldName === 'frequencyDetails' && sweepFrequency.frequencyType.value === MONTHLY && sweepFrequency.frequencyDetails.value === SPECIFIC_DAY) {
      sweepFrequency.frequencyDetailValue = this.defaultPicks[SPECIFIC_DAY];
      sweepFrequency.annualDate = undefined;
      sweepFrequency.dates = undefined;
    }
    return sweepFrequency;
  }

  setSweepFrequencyDropDownSubValue = (event) => {
    var fieldName = event.target.name;
    if (event.target.name === 'frequencyType' && document.getElementById('holidayAdjustmentOptionField') !== null && document.getElementById('holidayAdjustmentOptionField') !== undefined && event.target.value !== "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:daily" && this.props.crossBorder === 'crossBorder') {
      document.getElementById('holidayAdjustmentOptionField').classList.remove('noDisplay');
    }
    var sweepFrequency = {
      ...this.state.sweepFrequency,
      [event.target.name]: {
        name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
        value: event.target.value
      },
      isNAChecked: false
    };
    sweepFrequency = this.setDefaultSelections(fieldName, { ...sweepFrequency });
    this.setState({ sweepFrequency, isDisabled: false, isNAChecked: false }, () => {
      this.props.setInputvalue(this.state.sweepFrequency, this.props.name);
    });
    this.setState({ validationMgs: false })
  }

  setAnnualDateValue = (event) => {
    var sweepFrequency = {
      ...this.state.sweepFrequency,
      [event.target.name]: event.target.value
    };
    this.setState({ sweepFrequency }, () => {
      this.props.setInputvalue(this.state.sweepFrequency, this.props.name);
    });
  }

  setCalenderValues = (index, event) => {
    const re = /^[0-9]+$/;
    if (event.target.value === '' || re.test(event.target.value)) {
      var dates = [...this.state.sweepFrequency.dates];
      dates[index] = event.target.value;
      this.setState({ sweepFrequency: { ...this.state.sweepFrequency, dates } }, () => {
        this.props.setInputvalue(this.state.sweepFrequency, this.props.name);
      });
    }
  }
  validateDate = (event) => {
    var first = event.target.value.slice(0, 2);
    var second = event.target.value.slice(2, 4);
    if (event.target.value.length === 0) {
      this.setState({ validationMgs: false })
    }
    if (event.target.value.length < 4 && event.target.value.length !== 0) {
      return this.setState({ validationMgs: true })
    }
    if (event.target.value.length === 4) {
      if (first > 31 || second > 12) {
        this.setState({ validationMgs: true })
      }
    }
    if (first <= 31 && second <= 12 && second !== '' && first !== '') {
      this.setState({ validationMgs: false })
    } else if (second !== '' && first !== '') {
      this.setState({ validationMgs: true })
    }
    return false;
  }

  getSubFieldOptions = (sweepType, subType) => {
    if (subType) {
      return this.state.sweepFrequencyDataDictionary
        .find(sfType => sfType.id === sweepType)
        .associations
        .find(_subType => _subType.id === subType)
        .associations;
    } else {
      return this.state.sweepFrequencyDataDictionary
        .find(sfType => sfType.id === sweepType)
        .associations;
    }
  }

  onSweepDateAddition = (index, e) => {
    e.preventDefault();
    var dates = [...this.state.sweepFrequency.dates];
    dates[index] = '';
    this.setState(prevState => {
      return {
        noOfDates: prevState.noOfDates + 1,
        sweepFrequency: { ...this.state.sweepFrequency, dates },
      }
    });
  }

  onSweepDateDeletion = (index) => {
    var dates = [...this.state.sweepFrequency.dates];
    dates.splice(index, 1);
    this.setState(prevState => {
      return {
        sweepFrequency: { ...prevState.sweepFrequency, dates },
        noOfDates: prevState.noOfDates - 1
      }
    }, () => {
      this.props.setInputvalue(this.state.sweepFrequency, this.props.name);
    });
  }

  handleChange(event) {
    let sweepFrequency = {}
    let fieldName = event.target.name;
    if (event.target.name === "ANNUALLY") {
      this.setState({ isDisabled: event.target.value });
      sweepFrequency = {
        ...this.state.sweepFrequency,
        annualDate: '',
        isNAChecked: event.target.value
      };
    } if (event.target.name === "CALENDAR") {
      this.setState({ isDisabled: event.target.value });
      sweepFrequency = {
        ...this.state.sweepFrequency,
        dates: [],
        isNAChecked: event.target.value
      };
    } else if (event.target.name === "WEEKLY" || event.target.name === "MONTHLY" || event.target.name === "QUARTERLY") {
      this.setState({ isDisabled: event.target.value });
      sweepFrequency = {
        ...this.state.sweepFrequency,
        frequencyDetails: {
          name: '',
          value: ''
        },
        isNAChecked: event.target.value
      };
    }
    sweepFrequency = this.setDefaultSelections(fieldName, { ...sweepFrequency });
    let settlementType = {
      name: 'N/A',
      value: 'na'
    };
    this.setState({ sweepFrequency, settlementType, isNAChecked: event.target.value }, () => {
      this.props.setInputvalue(sweepFrequency, this.props.name);
      this.props.setInputvalue(settlementType, 'settlementType');
    });
  }

  render() {
    var datesJsx = [];
    for (var i = 1; i < this.state.noOfDates; i++) {
      datesJsx.push(
        <div className="sweep-date-section-wrapper clearfix gdocs-mtop-15 gdocs-mbottom-15" key={i}>
          <label className="sweep-date-section__label">{`${this.props.subLabels[0]} ${i + 1}`}</label>
          <div className="sweep-date-section__input-section">
            <input type="text"
              name={`dates${i}`}
              placeholder="DD MM"
              maxLength="4"
              value={this.state.sweepFrequency.dates !== undefined && this.state.sweepFrequency.dates.length > 0 ? this.state.sweepFrequency.dates[i] : ''}
              onChange={this.setCalenderValues.bind(this, i)} />
          </div>
          <i className="icon icon-bin" onClick={this.onSweepDateDeletion.bind(this, i)}></i>
        </div>
      )
    }
    if (this.props.lang.currentLang.lang === "English") {
      this.defaultDropdownValue = "Please Select"
    } else if (this.props.lang.currentLang.lang === "Spanish") {
      this.defaultDropdownValue = "Seleccione"
    } else if (this.props.lang.currentLang.lang === "Bahasa") {
      this.defaultDropdownValue = "Harap pilih"
    }
    return (this.state.sweepFrequencyDataDictionary.length > 0 ? (
      <div className="sweep-frequency-picker clearfix gdocs-mtop-15">
        <label className="sweep-frequency-picker__label">{this.props.boxLabel || "Sweep frequency"}</label>
        <div className="sweep-frequency-picker__input-section">
          <SimpleDropdown name='frequencyType'
            options={this.state.sweepFrequencyDataDictionary}
            disabled={this.props.disabled}
            optionTextSelector="name"
            showPleaseSelectOption={false}
            value={this.state.sweepFrequency['frequencyType'].value}
            width="198px"
            _onChange={this.setSweepFrequencyDropDownSubValue} />
        </div>
        <div className="clearBth"></div>
        {
          this.state.sweepFrequency.frequencyType.value === WEEKLY ? (
            <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--weekly gdocs-mtop-15">
              <label className="sweep-frequency-picker__input-label gdoc-annually-label-align">{this.props.subLabels[0] || "Day of the Week"}</label>
              <SimpleDropdown name='frequencyDetails'
                options={this.getSubFieldOptions(WEEKLY)}
                disabled={this.state.sweepFrequency.isNAChecked}
                optionTextSelector="name"
                showPleaseSelectOption={true}
                value={this.state.sweepFrequency['frequencyDetails'].value}
                width="198px"
                defaultValue={this.defaultDropdownValue}
                _onChange={this.setSweepFrequencyDropDownSubValue} />
              {
                this.props.isCheckShow === undefined &&
                <div class="optional-text-box__checkbox checkBox-weekly">
                  <div class="checkbox__container ">
                    <input id="WEEKLY" name="WEEKLY" class="gdocs-checkbox" type="checkbox" checked={this.state.sweepFrequency.isNAChecked} onChange={(e) => {
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.checked,
                        },
                      });
                    }} />
                    <label class="gdocs-checkbox__label" for="WEEKLY" aria-labelledby="WEEKLY">
                      <span class="tick-mark"></span>
                    </label>
                  </div>
                  <label for="date_NALabel" class="label-NA">N/A</label>
                </div>
              }
            </div>
          ) : ''
        }
        {
          this.state.sweepFrequency.frequencyType.value === QUARTERLY ? (
            <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--weekly gdocs-mtop-15">
              <label className="sweep-frequency-picker__input-label gdoc-annually-label-align">{this.props.subLabels[0] || "Every"}:</label>
              <SimpleDropdown name='frequencyDetails'
                options={this.getSubFieldOptions(QUARTERLY)}
                disabled={this.state.sweepFrequency.isNAChecked}
                optionTextSelector="name"
                showPleaseSelectOption={false}
                value={this.state.sweepFrequency['frequencyDetails'] !== undefined && this.state.sweepFrequency['frequencyDetails'] !== null ? this.state.sweepFrequency['frequencyDetails'].value : ''}
                width="198px"
                defaultValue={this.defaultDropdownValue}
                _onChange={this.setSweepFrequencyDropDownSubValue} />
              {
                this.props.isCheckShow === undefined &&
                <div class="optional-text-box__checkbox checkBox-quartely">
                  <div class="checkbox__container ">
                    <input id="QUARTERLY" name="QUARTERLY" class="gdocs-checkbox" type="checkbox" checked={this.state.sweepFrequency.isNAChecked} onChange={(e) => {
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.checked,
                        },
                      });
                    }} />
                    <label class="gdocs-checkbox__label" for="QUARTERLY" aria-labelledby="QUARTERLY">
                      <span class="tick-mark"></span>
                    </label>
                  </div>
                  <label for="date_NALabel" class="label-NA">N/A</label>
                </div>
              }
            </div>
          ) : ''
        }
        {
          this.state.sweepFrequency.frequencyType.value === MONTHLY ? (
            <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--monthly gdocs-mtop-15">
              <label className="sweep-frequency-picker__input-label gls-sweep-freq-picker__input-align gdoc-margin-rt">{this.props.subLabels[0] || "Day of the Month"}</label>
              <div className="gls-sweep-freq-picker__input-align">
                <SimpleDropdown name='frequencyDetails'
                  options={this.getSubFieldOptions(MONTHLY)}
                  disabled={this.state.sweepFrequency.isNAChecked}
                  optionTextSelector="name"
                  showPleaseSelectOption={true}
                  defaultValue={this.props.defaultValue || this.defaultDropdownValue}
                  value={this.state.sweepFrequency['frequencyDetails'].value || ""}
                  width="215px"
                  _onChange={this.setSweepFrequencyDropDownSubValue} />
                {
                  this.props.isCheckShow === undefined &&
                  <div class="optional-text-box__checkbox checkBox-monthly">
                    <div class="checkbox__container ">
                      <input id="MONTHLY" name="MONTHLY" class="gdocs-checkbox" type="checkbox" checked={this.state.sweepFrequency.isNAChecked} onChange={(e) => {
                        this.handleChange({
                          target: {
                            name: e.target.name,
                            value: e.target.checked,
                          },
                        });
                      }} />
                      <label class="gdocs-checkbox__label" for="MONTHLY" aria-labelledby="MONTHLY">
                        <span class="tick-mark"></span>
                      </label>
                    </div>
                    <label for="date_NALabel" class="label-NA">N/A</label>
                  </div>
                }
              </div>
              <div className="clearBth"></div>
              {
                this.state.sweepFrequency.frequencyDetails.value === SPECIFIC_DAY ? (
                  <div className="gdocs-mtop-15">
                    <label className="sweep-frequency-picker__input-label choose-day gls-sweep-spec-day-label-align">{this.props.subLabels[1] || "Specific day of the month"}</label>
                    <div className="gls-sweep-freq-picker__input-align">
                      <SimpleDropdown bsClass='specific-day-values inline-grid'
                        name='frequencyDetailValue'
                        options={this.getSubFieldOptions(MONTHLY, SPECIFIC_DAY)}
                        disabled={this.props.disabled}
                        optionTextSelector="name"
                        showPleaseSelectOption={false}
                        width="98px"
                        value={this.state.sweepFrequency['frequencyDetailValue'].value}
                        _onChange={this.setSweepFrequencyDropDownSubValue} />
                    </div>
                    <div className="clearBth"></div>
                  </div>
                ) : ''
              }
            </div>
          ) : ''
        }
        {
          this.state.sweepFrequency.frequencyType.value === ANNUALLY ? (
            <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--annually gdocs-mtop-15">
              <label className="sweep-frequency-picker__input-label gdoc-annually-label-align">{this.props.subLabels[0] || "Date of Year"}</label>
              <input type="text"
                name="annualDate"
                disabled={this.state.sweepFrequency.isNAChecked}
                placeholder="DD MM"
                onBlur={this.validateDate}
                maxLength="4"
                value={this.state.sweepFrequency.annualDate}
                onChange={this.setAnnualDateValue} />
              {this.state.validationMgs ? <span className="input-error-msg-section">
                <span className="icon icon-circle-delete-solid"></span>{this.props.mandatoryMessage}</span> : ''}
              {
                this.props.isCheckShow === undefined &&
                <div class="optional-text-box__checkbox checkBox-annually">
                  <div class="checkbox__container ">
                    <input id="ANNUALLY" name="ANNUALLY" class="gdocs-checkbox" type="checkbox" checked={this.state.sweepFrequency.isNAChecked} onChange={(e) => {
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.checked,
                        },
                      });
                    }} />
                    <label class="gdocs-checkbox__label" for="ANNUALLY" aria-labelledby="ANNUALLY">
                      <span class="tick-mark"></span>
                    </label>
                  </div>
                  <label for="date_NALabel" class="label-NA">N/A</label>
                </div>
              }
            </div>
          ) : ''
        }
        {
          this.state.sweepFrequency.frequencyType.value === CALENDER_DATE ? (
            <div className="sweep-frequency-picker__input-section sweep-frequency-picker__input-section--calender">
              <div className="sweep-date-section">
                <div className="sweep-date-section-wrapper clearfix">
                  <label className="sweep-date-section__label">{this.props.subLabels[0] || "Sweep Date"} 1</label>
                  <div className="sweep-date-section__input-section">
                    <input type="text"
                      name="dates0"
                      disabled={this.state.sweepFrequency.isNAChecked}
                      placeholder="DD MM"
                      maxLength="4"
                      onBlur={this.validateDate}
                      value={this.state.sweepFrequency.dates[0] ? this.state.sweepFrequency.dates[0] : ''}
                      onChange={this.setCalenderValues.bind(this, 0)} />
                    {this.state.validationMgs ? <span className="input-error-msg-section">
                      <span className="icon icon-circle-delete-solid"></span>{this.props.mandatoryMessage}</span> : ''}
                  </div>
                </div>
                {datesJsx}
                <button className="gdocs-btn-default" disabled={this.state.sweepFrequency.isNAChecked} onClick={this.onSweepDateAddition.bind(this, i)}><i className="icon icon-add"></i> {this.props.subLabels[3] || "Add another"}</button>
              </div>
              {
                this.props.isCheckShow === undefined &&
                <div class="optional-text-box__checkbox checkBox-calen">
                  <div class="checkbox__container ">
                    <input id="CALENDAR" name="CALENDAR" class="gdocs-checkbox" type="checkbox" checked={this.state.sweepFrequency.isNAChecked} onChange={(e) => {
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.checked,
                        },
                      });
                    }} />
                    <label class="gdocs-checkbox__label" for="CALENDAR" aria-labelledby="CALENDAR">
                      <span class="tick-mark"></span>
                    </label>
                  </div>
                  <label for="date_NALabel" class="label-NA">N/A</label>
                </div>
              }
            </div>
          ) : ''
        }
      </div>
    ) : '');
  }
}

SweepFrequencyPicker.propTypes = {
  name: PropTypes.string.isRequired,
  subLabels: PropTypes.array.isRequired,
  subNames: PropTypes.array.isRequired,
  setInputvalue: PropTypes.func.isRequired,
  dataDictionaryURI: PropTypes.string,
  dataDictionary: PropTypes.object,
  _value: PropTypes.object
}

const mapStateToProps = state => {
  return {
    crossBorder: state.currentProductGlsCashcon.crossBorder,
    lang: state.lang
  }
}

export default connect(mapStateToProps, null)(SweepFrequencyPicker);



// WEBPACK FOOTER //
// ./src/components/common/SweepFrequencyPicker/SweepFrequencyPicker.js